import clsx from 'clsx';

interface SectionTitleProps {
  title?: string;
  subtitle?: string;
  color?: 'default' | 'contrast';
}

const SectionTitle = ({ title, subtitle, color = 'default' }: SectionTitleProps) => {
  if (!title && !subtitle) return null;

  const colorClass = color === 'contrast' ? 'text-white' : 'text-v1-background-200';

  return (
    <>
      {title ? (
        <h2
          className={clsx(
            'text-center typography-v1-legacy-h2',
            colorClass,
            subtitle ? 'mx-4 mb-5' : 'mx-2 mb-8 sm:mx-4 sm:mb-12 xl:mb-16',
          )}
        >
          {title}
        </h2>
      ) : null}
      {subtitle ? (
        <h3
          className={clsx(
            'mx-2 mb-8 text-center typography-v1-legacy-subtitle2 sm:mx-4 sm:mb-12 xl:mb-16',
            colorClass,
          )}
        >
          {subtitle}
        </h3>
      ) : null}
    </>
  );
};

export default SectionTitle;
